import { USER_ROLES } from "@/constants";

const systemRoutes = [
  {
    path: "",
    redirect: {
      name: "systemOverview",
    },
    component: () => import("@/views/System/App.vue"),
    meta: {
      authorize: [USER_ROLES.SYSTEM, USER_ROLES.SALES],
    },
  },
  {
    path: "settings",
    redirect: {
      name: "system-settings-saml-sso",
    },
    children: [
      {
        path: "saml-sso",
        name: "system-settings-saml-sso",
        component: () => import("@/views/System/Settings/Saml/index.vue"),
      },
    ],
  },
  {
    path: "dashboard",
    name: "systemOverview",
    component: () => import("@/views/System/Overview/index.vue"),
  },
  {
    path: ":id",
    redirect: (to) => ({
      name: "systemOverviewChild",
      params: { id: to.params.id },
    }),
  },
  {
    path: ":id/dashboard",
    name: "systemOverviewChild",
    component: () => import("@/views/System/Overview/index.vue"),
  },
];

export default systemRoutes;
